import type React from 'react'

import { MarkerF, type MarkerProps } from '@react-google-maps/api'

import { svgRequestMarker } from '@/components/atoms/MapSvgMarker/svgRequestMarker.ts'

import { markerLabel } from './markerLabel.ts'

export type PendingRequestMarkerProps = { label: string; children?: React.ReactNode } & Omit<
  MarkerProps,
  'icon' | 'label'
>

export const PendingRequestMarker: React.FC<PendingRequestMarkerProps> = ({ label, children, ...props }) => (
  <MarkerF
    {...props}
    label={markerLabel(label, 'pending', '#fff')}
    icon={{
      url: `data:image/svg+xml;utf-8,${encodeURIComponent(svgRequestMarker('pending'))}`,
      scaledSize: new google.maps.Size(36, 36),
      labelOrigin: new google.maps.Point(18, 18),
    }}>
    {children}
  </MarkerF>
)
